<template>
    <div>
    	<van-nav-bar
		  	title="请输入预约信息"
			left-arrow
		  	@click-left="$router.push('/')">
		</van-nav-bar>
		<van-field 
			label='姓名'

			placeholder="请输入姓名"
		></van-field>
		<van-field
			class="inputAr"
		  	label="性别:"
		  	readonly
		  	clickable
		  	right-icon="arrow"
		  	:value="genderText"
		  	@click="showGenderPicker=true"
		/>
		<van-popup v-model="showGenderPicker" position="bottom">
		  	<van-picker
			    show-toolbar
			    :columns="genders"
			    @cancel="showGenderPicker = false"
		  	/>
		</van-popup>
		<van-field 
			label='电话号码'

			placeholder="请输入电话号码"
		> <van-button v-if='isSms==false' slot="button" size="small" type="primary" >发送验证码</van-button>
		<van-button v-else slot="button" size="small" type="primary" :disabled='isSms'><span>{{timer}}</span>秒后重新获取</van-button>
		</van-field>
		<van-field 
			label='验证码'

			placeholder="请输入验证码"
		></van-field>

		<van-button class="certainBtn" round type="default"  style="font-weight:bold;font-size:16px;">确定</van-button>
    </div>
</template>
<script>
  	export default {
  		data(){
  			return{
  				genderText:'男',
  				showGenderPicker:false,
  				genders:[
	      			{
	      				value:0,
	      				text:'女',
	      			},
	      			{
	      				value:1,
	      				text:'男'
	      			}
	      		],
	      		isSms:false,
	      		timer:60
  			}
  		}
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #000;
	}
	.certainBtn{
		width: 90%;
		height: 40px;
		line-height: 40px;
		margin-left: 5%;
		margin-top: 30px;
		background:linear-gradient(90deg,#FFC914,#FFB20D);
		color: #222;
		font-weight: bold;
		border: none;
	}
</style>


// WEBPACK FOOTER //
// src/service/InputBookInfo.vue